

import { useForm as useInertiaForm, router } from '@inertiajs/react'

export function useFormExtended<T extends Record<string, any>>(initialValues: T) {
  const form = useInertiaForm(initialValues)

  // custom helper
  function post(url: string, options: {redirectBack?: boolean, directOrder?: boolean} & Parameters<typeof form.post>[1] = {}) {
    const {redirectBack, directOrder, ...restOptions} = options
    form.transform((data) => ({
      ...data,
      redirect_back: redirectBack,
      direct_order: directOrder,
    }))
    form.post(url, restOptions)
  }

  return {
    ...form,
    post,
  }
}

export default useFormExtended;